import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { TranslocoLocaleWrapperService } from 'app/fuse-template/core/transloco/translocoLocale.service';
import { copyLink } from 'app/helpers/copyLink';
import { formatDate } from 'app/helpers/formatDate';
import { sortCompare } from 'app/helpers/sortCompare';
import { DropDownItem } from 'app/interfaces/items/dropDownItem';
import { CreateGengiEignirReq } from 'app/interfaces/requests/Create/createGengiEignirReq';
import { CreateGengiReq } from 'app/interfaces/requests/Create/createGengiReq';
import { CreateGengiUnsettledTradesReq } from 'app/interfaces/requests/Create/createGengiUnsettledTradesReq';
import { ExposedGengiSkraningReq } from 'app/interfaces/requests/Exposed/exposedGengiSkraningReq';
import { ExposedListMarketValueOverviewDivisionRes } from 'app/interfaces/responses/Exposed/exposedlistMarketValueOverviewDivisionRes';
import { ExposedReadAdditionalValuesRegisteredRateRes } from 'app/interfaces/responses/Exposed/exposedReadAdditionalValuesRegisteredRateRes';
import { ListKriaDagsuppgjorRes } from 'app/interfaces/responses/List/listKriaDagsuppgjorRes';
import { ReadKriaSidastaGengiRes } from 'app/interfaces/responses/Read/readKriaSidastaGengiRes';
import { ReadMarketValuePortfolioRes } from 'app/interfaces/responses/Read/readMarketValuePortfolioRes';
import { GengiFormFieldsContent } from 'app/interfaces/support/gengi/gengiFormFieldsContent';
import { GengiService } from 'app/services/api/gengi/gengi.service';
import { TranslationService } from 'app/services/api/translation/translation.service';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { lsrDivisionsConstants } from 'common/constants/lsrDivisions.contants';
import moment from 'moment';
import { combineLatest } from 'rxjs';

@Component({
    selector: 'app-gengi-skra',
    templateUrl: './gengi-skra.component.html',
    styleUrls: ['./gengi-skra.component.scss'],
})
export class GengiSkraComponent implements OnInit {
    //#region Global Variables
    @ViewChild('tablePaginator') displayedDataPaginator: MatPaginator;
    headerColumnsInitial: string[] = [
        'symbol',
        'closingPriceToday',
        'closingPriceBefore',
        'marketValueToday',
        'marketValueBefore',
        'closingPriceDifference',
    ];
    headerColumnsDataChange: string[] = [
        'changeType',
        'symbol',
        'closingPriceToday',
        'closingPriceBefore',
        'marketValueToday',
        'marketValueBefore',
        'closingPriceDifference',
    ];
    headerColumns: string[] = this.headerColumnsInitial;

    // Almennt
    todayDate: Date = new Date();
    formEnabled = true;
    form: UntypedFormGroup;
    initialGengiFormFieldsContent: GengiFormFieldsContent = new GengiFormFieldsContent();
    currentGengiFormFieldsContent: GengiFormFieldsContent = new GengiFormFieldsContent();

    // Gengi
    thegarHefurVeridSkradGengi = false;
    gengiDagsinsSkrad: number;
    sidastaSkradaGengi: ReadKriaSidastaGengiRes;
    mismunurFraSidustuSkraningu: number;
    skraGengiSimple: boolean = false;
    skraGengiEnabled: boolean = false;

    // VidskiptiGaerdagsins og útistandandiEiningar
    dagsuppgjorEntry: ListKriaDagsuppgjorRes;

    // Markaðsverð eigna
    markadsverdRes: ReadMarketValuePortfolioRes;

    // Eignir
    displayedData: MatTableDataSource<ExposedListMarketValueOverviewDivisionRes> = new MatTableDataSource();
    eignir: ExposedListMarketValueOverviewDivisionRes[];
    currentDWAssetsInPortfolio: ExposedListMarketValueOverviewDivisionRes[];
    changesInAssetsPortfolio: ExposedListMarketValueOverviewDivisionRes[];

    // Viðbót við markaðsverð og viðbótarupplýsingar geymdar fyrir gengi
    additionalValuesRegisteredRateRes: ExposedReadAdditionalValuesRegisteredRateRes;

    // Óuppgerð verðbréfaviðskipti - hreyfingar
    apxTransactionsAssetsColumns: string[] = ['Meðtalið í útreikningi', 'symbolAPX', 'transactionCode', 'tradeDate', 'settleDate', 'postDate', 'tradeAmount'];
    apxTransactionsAssetsTableSource: MatTableDataSource<AbstractControl<any, any>>;
    initialApxTransactionsAssetsArray: FormArray<any>;
    currentApxTransactionsAssetsArray: FormArray<any>;
    totalAmount: number = 0;
    showApxTransactionsAssets = false;

    // Vísitala
    assetsIndexValuesColumns: string[] = ['seriesIdentifier', 'dateTodayValue', 'dateBeforeValue', 'difference'];
    assetsIndexValuesTableSource: MatTableDataSource<AbstractControl<any, any>>;

    // Checkbox breytingar á eignarsafni
    showComparison: boolean = false;

    // Dropdown listi
    sereignarleidir: Array<DropDownItem> = [
        {
            value: lsrDivisionsConstants.lsr1,
            viewValue: 'Verðbréfaleið (LSR1)',
        },
        {
            value: lsrDivisionsConstants.lsr3,
            viewValue: 'Innlánaleið (LSR3)',
        }
    ];

    //#endregion

    //#region Init
    constructor(
        private _fuseConfirmationService: FuseConfirmationService,
        private _formBuilder: UntypedFormBuilder,
        private gengiService: GengiService,
        private formBuilder: UntypedFormBuilder,
        private alertsService: AlertsService,
        private localeService: TranslocoLocaleWrapperService,
        private translationService: TranslationService
    ) {
        this.checkPage();
        this.initForm();
    }

    ngOnInit(): void {
        this.additionalMarketValueChanges();
        this.unsettledSecuritiesTransactionsValueChanges();
        this.commentsValueChanges();
    }

    additionalMarketValueChanges() {
        this.form.get('vidbotVidMarkadsverd')!.valueChanges.subscribe(value => {

            if (!this.additionalValuesRegisteredRateRes) {
                this.currentGengiFormFieldsContent.vidbotVidMarkadsverd = value;

                if (this.dagsuppgjorEntry) {
                    this.calculateGengi();
                }
            }
            else if (this.showComparison) {
                this.currentGengiFormFieldsContent.vidbotVidMarkadsverd = value;
                this.calculateGengi();
            }
        });
    }

    unsettledSecuritiesTransactionsValueChanges() {
        this.form.controls.ouppgerdVerdbrefavidskiptiUpplysingar.valueChanges.subscribe((value) => {
            var apxTransactionsAssetsArray = this.form.get('ouppgerdVerdbrefavidskiptiUpplysingar') as FormArray;
            this.getTotalAmountUnsettledSecuritiesTransactions(apxTransactionsAssetsArray);

            if (!this.additionalValuesRegisteredRateRes) {
                this.initialGengiFormFieldsContent.ouppgerdVerdbrefavidskipti = this.totalAmount.toString();
                this.form.patchValue({ ouppgerdVerdbrefavidskipti: this.formatNumber(this.initialGengiFormFieldsContent.ouppgerdVerdbrefavidskipti) });

                this.currentGengiFormFieldsContent.ouppgerdVerdbrefavidskipti = this.totalAmount.toString();
                this.form.patchValue({ ouppgerdVerdbrefavidskipti: this.formatNumber(this.currentGengiFormFieldsContent.ouppgerdVerdbrefavidskipti) });
            }
            else if (this.showComparison) {
                this.currentGengiFormFieldsContent.ouppgerdVerdbrefavidskipti = this.totalAmount.toString();
                this.form.patchValue({ ouppgerdVerdbrefavidskipti: this.formatNumber(this.currentGengiFormFieldsContent.ouppgerdVerdbrefavidskipti) });
            }

            if (this.dagsuppgjorEntry && this.showComparison) {
                this.calculateGengi();
            }
        });
    }

    commentsValueChanges() {
        this.form.get('comments')!.valueChanges.subscribe(value => {
            if (!this.additionalValuesRegisteredRateRes) {
                this.currentGengiFormFieldsContent.comments = value;
            }
            else if (this.showComparison) {
                this.currentGengiFormFieldsContent.comments = value;
            }
        });
    }

    checkPage() {
        if (window.location.href.includes('skra-gengi-ohad')) {
            this.skraGengiSimple = true;
        }
    }

    ngAfterViewInit(): void {
        this.displayedData.paginator = this.displayedDataPaginator;
    }

    public printOrSave() {
        window.print();
    }

    //#endregion

    //#region Http functions

    // Sækir síðasta skráða gengi í Kríu
    saekiSidastaSkradaGengi(division) {
        this.gengiService.kriaSidastaGengi({ division: division }).subscribe((gengi) => {
            this.sidastaSkradaGengi = gengi;
            this.calculateGengiDifference();
        });
    }

    // Sækir helstu upplýsingar sem þarf til að reikna út gengi.
    fetchData() {
        this.showComparison = false;
        const skammstofun = this.selectedDivision();
        this.thegarHefurVeridSkradGengi = false;
        const selectedDate = new Date(this.form.get('dagsetning').value);

        // VidskiptiGaerdagsins og útistandandiEiningar - upplýsingar úr Kría.
        const fetchDagsuppgjor = this.gengiService.kriaDagsuppgjor({
            dagsGengi: this.form.get('dagsetning').value,
        });

        // Markaðsverð eigna.
        const fetchMarkadsverd = this.gengiService.markadsvirdiLeidar({
            division: this.form.get('sereignarleid').value,
            dagsetning: this.getCalendarPreviousDayOrFriday(selectedDate),
        });

        // Viðbótarupplýsingar fyrir gengi tiltekinnar leiðar frá gagnagrunni LSR.
        const additionalValuesRegisteredRate = this.gengiService.readAdditionalValuesRegisteredRate({
            divisionAbbreviation: skammstofun,
            date: this.form.get('dagsetning').value
        });

        // Sækir eignir innan tiltekinnar leiðar.  Skilar lista yfir gamalt gildi, nýtt gildi úr DW og breytingar á milli.
        const fetchMarketValueOverviewPortfolioSimple = this.gengiService.listMarketValueOverviewDivision({
            division: this.form.get('sereignarleid').value,
            dateToday: this.getCalendarPreviousDayOrFriday(selectedDate),
            dateBefore: this.getCalendarTwoDaysBeforeOrThursday(selectedDate),
            selectedDate: selectedDate,
        });

        // Listi yfir óuppgerð verðbréfaviðskipti úr DW.
        const fetchAPXTransactionsAssets = this.gengiService.listAPXTransactionsAssets({
            division: this.form.get('sereignarleid').value,
            divisionAbbreviation: skammstofun,
            marketDate: this.getCalendarPreviousDayOrFriday(selectedDate),
            selectedDate: selectedDate,
        });

        // Vísitala.
        const assetIndexValues = this.gengiService.listAssetsIndexValues({
            dateToday: this.getCalendarPreviousDayOrFriday(selectedDate),
            dateBefore: this.getCalendarTwoDaysBeforeOrThursday(selectedDate),
        });

        const afterCall = (markadsverdRes, dagsuppgjorRes, marketValueOverviewPortfolioSimpleRes, fetchAPXTransactionsAssetsRes, assetIndexValuesRes, additionalValuesRegisteredRateRes) => {
            this.markadsverdRes = markadsverdRes;
            this.additionalValuesRegisteredRateRes = additionalValuesRegisteredRateRes;

            // Hreyfingalisti - Óuppgerð verðbréfaviðskipti.
            this.getApxTransactionsAssetsList(fetchAPXTransactionsAssetsRes);

            // Vísitala.
            this.getAssetIndexValuesList(assetIndexValuesRes);

            // VidskiptiGaerdagsins og útistandandiEiningar.
            this.dagsuppgjorEntry = null;
            if (this.form.get('sereignarleid').value == lsrDivisionsConstants.lsr1) {
                this.dagsuppgjorEntry = dagsuppgjorRes.filter((x) => x.audkenni_Kria == 'LSR1')[0];
            } else if (this.form.get('sereignarleid').value == lsrDivisionsConstants.lsr3) {
                this.dagsuppgjorEntry = dagsuppgjorRes.filter((x) => x.audkenni_Kria == 'LSR3')[0];
            }

            // Sækir eignir innan tiltekinnar leiðar. 
            if (marketValueOverviewPortfolioSimpleRes.assetsInPortfolio.length > 0) {
                this.displayedData.data = marketValueOverviewPortfolioSimpleRes.assetsInPortfolio;
                this.eignir = marketValueOverviewPortfolioSimpleRes.assetsInPortfolio;
                this.changesInAssetsPortfolio = marketValueOverviewPortfolioSimpleRes.changesInAssetsPortfolio;
                this.currentDWAssetsInPortfolio = marketValueOverviewPortfolioSimpleRes.currentDWAssetsInPortfolio;
            } else {
                this.displayedData.data = [];
                this.eignir = [];
                this.changesInAssetsPortfolio = [];
                this.currentDWAssetsInPortfolio = [];
            }

            // Sækir síðasta skráða gengi í Kríu
            this.saekiSidastaSkradaGengi(skammstofun);

            this.gengiService
                .kriaSkradGengi({
                    skammstofun: skammstofun,
                    dagsGengi: moment(new Date(this.form.get('dagsetning').value)).format('YYYY-MM-DD'),
                })
                .subscribe((vidGengi) => {
                    if (vidGengi != null) {
                        this.gengiDagsinsSkrad = vidGengi.gengi;
                        this.thegarHefurVeridSkradGengi = true;
                    }
                });

            if (!this.skraGengiSimple) {
                if (this.dagsuppgjorEntry == null) {
                    alert('Ekkert dagsuppgjör í Kríu fannst fyrir valda dagsetningu');
                    this.form.get('vidskiptiGaerdagsins').setValue('');
                    this.form.get('utistandandiEiningar').setValue('');
                    this.form.get('markadsverd').setValue('');
                    this.form.get('gengi').setValue('');
                    this.mismunurFraSidustuSkraningu = null;
                    this.skraGengiEnabled = false;
                    return;
                } else {
                    this.getInitialGengiFormFieldsContent();
                    this.getCurrentGengiFormFieldsContent();

                    // Set values for form content.
                    if (this.additionalValuesRegisteredRateRes) {
                        this.setValueInitialGengiFormFieldsContent();
                    } else {
                        this.setValueCurrentGengiFormFieldsContent();
                    }

                    this.skraGengiEnabled = true;
                }
            }
        };

        combineLatest([fetchMarkadsverd, fetchDagsuppgjor, fetchMarketValueOverviewPortfolioSimple, fetchAPXTransactionsAssets, assetIndexValues, additionalValuesRegisteredRate]).subscribe(
            ([markadsverdRes, dagsuppgjorRes, marketValueOverviewPortfolioSimpleRes, fetchAPXTransactionsAssetsRes, assetIndexValuesRes, additionalValuesRegisteredRateRes]) => {
                afterCall(markadsverdRes, dagsuppgjorRes, marketValueOverviewPortfolioSimpleRes, fetchAPXTransactionsAssetsRes, assetIndexValuesRes, additionalValuesRegisteredRateRes);
            }
        );
    }

    //#endregion

    //#region General functions

    getInitialGengiFormFieldsContent() {
        // Útistandandi einingar.
        this.initialGengiFormFieldsContent.utistandandiEiningar = this.localeService.localizeNumber(this.dagsuppgjorEntry.einingar_Alls, 'decimal', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
        });

        // Hreyfingar úr réttindakerfi.
        this.initialGengiFormFieldsContent.vidskiptiGaerdagsins = this.localeService.localizeNumber(this.dagsuppgjorEntry.upphaed);

        // Sækir viðbótar gildi sem voru skráð við gengisskráningu á valinni dagsetningu.
        if (this.additionalValuesRegisteredRateRes != null) {
            this.disableAdditionalValuesRegisteredRate();

            // Markaðsverð eigna.
            this.initialGengiFormFieldsContent.markadsverd = this.additionalValuesRegisteredRateRes.marketValue.toString();

            //Viðbót við markaðsverð.
            this.initialGengiFormFieldsContent.vidbotVidMarkadsverd = this.additionalValuesRegisteredRateRes.additionToMarketValue.toString();

            // Óuppgerð verðbréfaviðskipti.
            this.initialGengiFormFieldsContent.ouppgerdVerdbrefavidskipti = this.additionalValuesRegisteredRateRes.unsettledSecuritiesTransactions.toString();  // string

            // Viðbótarupplýsingar.
            this.initialGengiFormFieldsContent.comments = this.additionalValuesRegisteredRateRes.comments;

            // Gengi.
            this.initialGengiFormFieldsContent.gengi = this.additionalValuesRegisteredRateRes.gengi.toString();

            // Set values for form content.
            this.setValueInitialGengiFormFieldsContent();

        }
    }

    getCurrentGengiFormFieldsContent() {
        // Útistandandi einingar.
        this.currentGengiFormFieldsContent.utistandandiEiningar = this.localeService.localizeNumber(this.dagsuppgjorEntry.einingar_Alls, 'decimal', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
        });

        // Hreyfingar úr réttindakerfi.
        this.currentGengiFormFieldsContent.vidskiptiGaerdagsins = this.localeService.localizeNumber(this.dagsuppgjorEntry.upphaed);

        // Markaðsverð eigna miðað við núverandi skráningu í DW.
        this.currentGengiFormFieldsContent.markadsverd = this.localeService.localizeNumber(this.markadsverdRes.marketValue);

        // Reikna gengi.
        this.calculateGengi();
    }

    setValueInitialGengiFormFieldsContent() {
        this.form.get('utistandandiEiningar').setValue(this.initialGengiFormFieldsContent.utistandandiEiningar);
        this.form.get('vidskiptiGaerdagsins').setValue(this.initialGengiFormFieldsContent.vidskiptiGaerdagsins);
        this.form.get('markadsverd').setValue(this.formatNumber(this.initialGengiFormFieldsContent.markadsverd));
        this.form.get('vidbotVidMarkadsverd').setValue(this.formatNumber(this.initialGengiFormFieldsContent.vidbotVidMarkadsverd));
        this.form.get('ouppgerdVerdbrefavidskipti').setValue(this.formatNumber(this.initialGengiFormFieldsContent.ouppgerdVerdbrefavidskipti));
        this.form.get('comments').setValue(this.initialGengiFormFieldsContent.comments);
        this.form.get('gengi').setValue(this.formatNumber(this.initialGengiFormFieldsContent.gengi));
    }

    setValueCurrentGengiFormFieldsContent() {
        this.form.get('utistandandiEiningar').setValue(this.currentGengiFormFieldsContent.utistandandiEiningar);
        this.form.get('vidskiptiGaerdagsins').setValue(this.currentGengiFormFieldsContent.vidskiptiGaerdagsins);
        this.form.get('markadsverd').setValue(this.currentGengiFormFieldsContent.markadsverd);
        this.form.get('vidbotVidMarkadsverd').setValue(this.formatNumber(this.currentGengiFormFieldsContent.vidbotVidMarkadsverd));
        this.form.get('ouppgerdVerdbrefavidskipti').setValue(this.formatNumber(this.currentGengiFormFieldsContent.ouppgerdVerdbrefavidskipti));
        this.form.get('comments').setValue(this.currentGengiFormFieldsContent.comments);
        this.calculateGengi();
    }

    // Vísitala.
    getAssetIndexValuesList(assetIndexValuesRes) {
        (this.form.get('assetsIndexValuesDetails') as FormArray).clear();
        var assetsIndexValuesArray = this.form.get('assetsIndexValuesDetails') as FormArray;
        assetIndexValuesRes.forEach((item) => {
            assetsIndexValuesArray.push(
                this._formBuilder.group({
                    seriesIdentifier: item.seriesIdentifier,
                    dateTodayValue: item.dateTodayValue,
                    dateBeforeValue: item.dateBeforeValue,
                    difference: item.difference,
                })
            )
        });
        this.assetsIndexValuesTableSource = new MatTableDataSource(assetsIndexValuesArray.controls);
    }

    // Hreyfingalisti - Óuppgerð verðbréfaviðskipti.
    getApxTransactionsAssetsList(fetchAPXTransactionsAssetsRes) {
        (this.form.get('ouppgerdVerdbrefavidskiptiUpplysingar') as FormArray).clear();
        this.initialApxTransactionsAssetsArray = this.form.get('ouppgerdVerdbrefavidskiptiUpplysingar') as FormArray;
        fetchAPXTransactionsAssetsRes.initialAPXTransactionsAssets.forEach((item) => {
            this.initialApxTransactionsAssetsArray.push(
                this._formBuilder.group({
                    isIncludedTotal: item.isIncludedTotal,
                    symbolAPX: item.symbolAPX,
                    transactionCode: item.transactionCode,
                    tradeDate: item.tradeDate,
                    settleDate: item.settleDate,
                    postDate: item.postDate,
                    tradeAmount: item.tradeAmount,
                })
            )
        });

        this.currentApxTransactionsAssetsArray = this.form.get('ouppgerdVerdbrefavidskiptiUpplysingar') as FormArray;
        fetchAPXTransactionsAssetsRes.currentAPXTransactionsAssets.forEach((item) => {
            this.currentApxTransactionsAssetsArray.push(
                this._formBuilder.group({
                    isIncludedTotal: item.isIncludedTotal,
                    symbolAPX: item.symbolAPX,
                    transactionCode: item.transactionCode,
                    tradeDate: item.tradeDate,
                    settleDate: item.settleDate,
                    postDate: item.postDate,
                    tradeAmount: item.tradeAmount,
                })
            )
        });

        this.initialGengiFormFieldsContent.ouppgerdVerdbrefavidskiptiUpplysingar = fetchAPXTransactionsAssetsRes.initialAPXTransactionsAssets;
        this.currentGengiFormFieldsContent.ouppgerdVerdbrefavidskiptiUpplysingar = fetchAPXTransactionsAssetsRes.currentAPXTransactionsAssets;

        if (this.initialGengiFormFieldsContent.ouppgerdVerdbrefavidskiptiUpplysingar.length > 0) {
            this.form.get('ouppgerdVerdbrefavidskiptiUpplysingar')?.disable();
            this.showApxTransactionsAssets = true;
            this.apxTransactionsAssetsTableSource = new MatTableDataSource(this.initialApxTransactionsAssetsArray.controls);
            this.getTotalAmountUnsettledSecuritiesTransactions(this.initialApxTransactionsAssetsArray)
            this.initialGengiFormFieldsContent.ouppgerdVerdbrefavidskipti = this.totalAmount.toString();
        }
        else if (this.currentGengiFormFieldsContent.ouppgerdVerdbrefavidskiptiUpplysingar.length > 0) {
            this.showApxTransactionsAssets = true;
            this.apxTransactionsAssetsTableSource = new MatTableDataSource(this.currentApxTransactionsAssetsArray.controls);
            this.getTotalAmountUnsettledSecuritiesTransactions(this.currentApxTransactionsAssetsArray);
            this.currentGengiFormFieldsContent.ouppgerdVerdbrefavidskipti = this.totalAmount.toString();
        } else {
            this.initialGengiFormFieldsContent.ouppgerdVerdbrefavidskipti = null;
            this.currentGengiFormFieldsContent.ouppgerdVerdbrefavidskipti = null;
        }

    }

    getTotalAmountUnsettledSecuritiesTransactions(apxTransactionsAssetsArray: any) {
        this.totalAmount = apxTransactionsAssetsArray.controls
            .filter(group => group.get('isIncludedTotal')?.value)
            .reduce((sum, group) => {
                return sum + Number(group.get('tradeAmount')?.value || 0);
            }, 0);
    }

    onShowComparisonNewOldDataChange(showComparison: boolean) {
        this.showComparison = showComparison;

        // Eignir.
        const data = showComparison ? this.changesInAssetsPortfolio : this.eignir;
        this.headerColumns = showComparison ? this.headerColumnsDataChange : this.headerColumnsInitial;
        this.displayedData.data = data;

        if (!this.additionalValuesRegisteredRateRes) {
            return;
        }

        if (showComparison) {
            // Þegar valið er að sýna samanburð birtast núverandi gögn úr DW á síðunni.
            this.setValueCurrentGengiFormFieldsContent();
            this.enableAdditionalValuesRegisteredRate();

            // Óuppgerð verðbréfaviðskipti.
            if (this.currentGengiFormFieldsContent.ouppgerdVerdbrefavidskiptiUpplysingar.length > 0 || this.showApxTransactionsAssets) {
                this.showApxTransactionsAssets = true;
                this.form.get('ouppgerdVerdbrefavidskiptiUpplysingar')?.enable();
                this.apxTransactionsAssetsTableSource = new MatTableDataSource(this.currentApxTransactionsAssetsArray.controls);
                this.getTotalAmountUnsettledSecuritiesTransactions(this.currentApxTransactionsAssetsArray);
                this.form.patchValue({ ouppgerdVerdbrefavidskipti: this.formatNumber(this.currentGengiFormFieldsContent.ouppgerdVerdbrefavidskipti) });
            } else {
                this.showApxTransactionsAssets = false;
            }
        } else {
            // Þegar samanburður er ekki valinn birtast á síðunni upphaflegu gögnin sem vistuð voru með gengisskráningunni.
            this.form.get('ouppgerdVerdbrefavidskiptiUpplysingar')?.disable();
            this.disableAdditionalValuesRegisteredRate();
            this.setValueInitialGengiFormFieldsContent();

            if (this.initialApxTransactionsAssetsArray.value.length > 0) {
                this.showApxTransactionsAssets = true;
                this.apxTransactionsAssetsTableSource = new MatTableDataSource(this.initialApxTransactionsAssetsArray.controls);
                this.getTotalAmountUnsettledSecuritiesTransactions(this.initialApxTransactionsAssetsArray);
                this.form.patchValue({ ouppgerdVerdbrefavidskipti: this.formatNumber(this.initialGengiFormFieldsContent.ouppgerdVerdbrefavidskipti) });
            } else {
                this.showApxTransactionsAssets = false;
            }
        }
    }

    //#endregion

    //#region Helper functions

    formatDate(date) {
        return formatDate(date, false);
    }

    formatNumber(value: any) {
        return this.localeService.localizeNumber(value, 'decimal', { maximumFractionDigits: 0 })
    }

    copyLink(v) {
        copyLink(v, 'Gengi afritað', this.alertsService);
    }

    toFixed(value, n) {
        return value.toFixed(n);
    }

    /**
     * Returns the previous day relative to `inputDate`.
     * If `inputDate` falls on a Saturday or Sunday, the function returns the previous Friday.
     */
    getCalendarPreviousDayOrFriday(inputDate: Date): Date {
        const result = new Date(inputDate); // clone the date
        const weekday = result.getDay(); // 0 = Sunday, 6 = Saturday

        if (weekday === 1) {
            // Monday -> go back 3 days to Friday
            result.setDate(result.getDate() - 3);
        } else if (weekday === 0) {
            // Sunday -> go back 2 days to Friday
            result.setDate(result.getDate() - 2);
        } else if (weekday === 6) {
            // Saturday -> go back 1 day to Friday
            result.setDate(result.getDate() - 1);
        } else {
            // Any other day -> simply go back 1 day
            result.setDate(result.getDate() - 1);
        }

        return result;
    }

    /**
     * Returns two days before `inputDate`.
     * If `inputDate` falls on a Saturday or Sunday, the function returns the previous Thursday.
     */
    getCalendarTwoDaysBeforeOrThursday(inputDate: Date): Date {
        const result = new Date(inputDate); // clone the date
        const weekday = result.getDay(); // 0 = Sunday, 6 = Saturday

        if (weekday === 1) {
            // Monday -> go back 4 days to Thursday
            result.setDate(result.getDate() - 4);
        } else if (weekday === 0) {
            // Sunday -> go back 3 days to Thursday
            result.setDate(result.getDate() - 3);
        } else {
            // For Saturday and weekdays -> go back 2 days
            // (For Saturday: -2 results in Thursday, matching the rule)
            result.setDate(result.getDate() - 2);
        }

        return result;
    }

    selectedDivision(): string {
        if (this.form.get('sereignarleid').value == lsrDivisionsConstants.lsr1) {
            return lsrDivisionsConstants.lsr1_short;
        } else if (this.form.get('sereignarleid').value == lsrDivisionsConstants.lsr3) {
            return lsrDivisionsConstants.lsr3_short;
        }
    }

    disableAdditionalValuesRegisteredRate() {
        if (this.additionalValuesRegisteredRateRes) {
            this.form.get('vidbotVidMarkadsverd')?.disable();
            this.form.get('comments')?.disable();
        }
    }

    enableAdditionalValuesRegisteredRate() {
        this.form.get('vidbotVidMarkadsverd')?.enable();
        this.form.get('comments')?.enable();
    }

    isAssetsSectionHidden() {
        return (this.eignir?.length == undefined && this.changesInAssetsPortfolio?.length == undefined) || (this.eignir?.length == 0 && this.changesInAssetsPortfolio?.length == 0);
    }

    //#endregion

    //#region Form

    initForm() {
        this.form = this.formBuilder.group({
            sereignarleid: new UntypedFormControl('', [Validators.required]),
            dagsetning: new UntypedFormControl(new Date(new Date().toDateString()), [Validators.required]),
            gengi: new UntypedFormControl({
                value: '',
                disabled: !this.skraGengiSimple,
            }),
            utistandandiEiningar: new UntypedFormControl({
                value: '',
                disabled: true,
            }),
            vidskiptiGaerdagsins: new UntypedFormControl({ value: '', disabled: true, }),
            vidbotVidMarkadsverd: new UntypedFormControl(''),
            ouppgerdVerdbrefavidskipti: new UntypedFormControl({ value: '', disabled: true }),
            comments: new UntypedFormControl(''),
            markadsverd: new UntypedFormControl({ value: '', disabled: true }),
            ouppgerdVerdbrefavidskiptiUpplysingar: this._formBuilder.array([]),
            assetsIndexValuesDetails: this._formBuilder.array([]),
        });
    }

    revertAllChanges() {
        if (confirm('Ertu viss um að þú viljir hætta við?')) {
            this.initializeValues();
            this.displayedData.data = [];
            this.sidastaSkradaGengi = null;
            this.thegarHefurVeridSkradGengi = false;
            this.form.markAsPristine();
            this.initForm();
        }
    }

    onChangeDate(date) {
        this.initializeValues();
        this.initialGengiFormFieldsContent.markadsverd = null;
        this.form.get('markadsverd').setValue('');
        this.form.get('dagsetning').setValue(date);
        this.form.get('vidbotVidMarkadsverd').setValue('');
        this.form.get('ouppgerdVerdbrefavidskipti').setValue('');
        this.form.get('comments').setValue('');
        if (this.form.get('sereignarleid').value != '') {
            this.fetchData();
        }
        this.checkSkraGengiEnabled();
    }

    onChangeLeid(leid) {
        this.form.get('sereignarleid').setValue(leid);
        this.initializeValues();
        this.form.get('vidbotVidMarkadsverd').setValue('');
        this.form.get('ouppgerdVerdbrefavidskipti').setValue('');
        this.form.get('comments').setValue('');
        this.initialGengiFormFieldsContent.markadsverd = null;
        this.form.get('markadsverd').setValue('');
        if (this.form.get('dagsetning').value != '') {
            this.fetchData();
        }
        this.checkSkraGengiEnabled();
    }

    initializeValues() {
        this.showComparison = false;
        this.headerColumns = this.headerColumnsInitial;
        this.initialGengiFormFieldsContent = new GengiFormFieldsContent();
        this.currentGengiFormFieldsContent = new GengiFormFieldsContent();
        this.showApxTransactionsAssets = false;
        this.enableAdditionalValuesRegisteredRate();
    }

    checkSkraGengiEnabled() {
        if (this.form.get('dagsetning').value != '' && this.form.get('sereignarleid').value != '') {
            this.skraGengiEnabled = true;
        } else {
            this.skraGengiEnabled = false;
        }
    }

    save() {
        let configForm = this._formBuilder.group({
            title: this.thegarHefurVeridSkradGengi ? 'Uppfæra gengi' : 'Skrá gengi',
            message:
                "Ertu viss um að þú viljir skrá gengi <strong>'" +
                this.form.get('gengi').value +
                "'</strong> fyrir dags. <strong>" +
                formatDate(this.form.get('dagsetning').value, false) +
                '</strong>, <strong>' +
                this.form.get('sereignarleid').value +
                '</strong>',
            icon: {
                show: true,
                name: 'heroicons_outline:exclamation',
                color: 'warn',
            },
            actions: {
                confirm: {
                    show: true,
                    label: 'Staðfesta',
                    color: 'warn',
                },
                cancel: {
                    show: true,
                    label: 'Hætta við',
                },
            },
            dismissible: true,
        });

        // Open the dialog and save the reference of it
        const dialogRef = this._fuseConfirmationService.open(configForm.value);

        // Subscribe to afterClosed from the dialog reference
        dialogRef.afterClosed().subscribe((result) => {
            if (result == 'confirmed') {
                const skammstofun = this.selectedDivision();

                // Þegar gögnin eru vistuð eru gögnin vistuð miðað við núverandi gögn úr DW á valinni dagsetningu.
                let gengiReq: CreateGengiReq = {
                    dagsetning: this.form.get('dagsetning').value,
                    skammstofun: skammstofun,
                    marketValue: this.localeService.parseLocalizedNumber(this.currentGengiFormFieldsContent.markadsverd),
                    divisionUnits: this.localeService.parseLocalizedNumber(this.currentGengiFormFieldsContent.utistandandiEiningar),
                    ydaTransactions: this.localeService.parseLocalizedNumber(this.currentGengiFormFieldsContent.vidskiptiGaerdagsins),
                    additionToMarketValue: this.localeService.parseLocalizedNumber(this.currentGengiFormFieldsContent.vidbotVidMarkadsverd),
                    unsettledSecuritiesTransactions: this.localeService.parseLocalizedNumber(this.currentGengiFormFieldsContent.ouppgerdVerdbrefavidskipti),
                    comments: this.currentGengiFormFieldsContent.comments,
                    gengi: this.localeService.parseLocalizedNumber(this.currentGengiFormFieldsContent.gengi),
                };

                const eignirReq: CreateGengiEignirReq[] = [];
                const gengiUnsettledTradesReq: CreateGengiUnsettledTradesReq[] = [];

                if (!this.skraGengiSimple) {
                    this.currentDWAssetsInPortfolio.forEach((e) => {
                        eignirReq.push({
                            closingPriceBefore: e.closingPriceBefore,
                            closingPriceDateBefore: e.closingPriceDateBefore,
                            closingPriceDateToday: e.closingPriceDateToday,
                            closingPriceDifference: e.closingPriceDifference,
                            closingPriceToday: e.closingPriceToday,
                            gengiId: null,
                            marketValueBefore: e.marketValueBefore,
                            marketValueToday: e.marketValueToday,
                            symbol: e.symbol,
                            symbolName: e.symbolName,
                            timeStamp: null,
                        });
                    });

                    this.form.get('ouppgerdVerdbrefavidskiptiUpplysingar').value.forEach((item) => {
                        gengiUnsettledTradesReq.push({
                            isIncludedTotal: item.isIncludedTotal,
                            gengiId: null,
                            symbolAPX: item.symbolAPX,
                            transactionCode: item.transactionCode,
                            tradeDate: item.tradeDate,
                            settleDate: item.settleDate,
                            postDate: item.postDate,
                            tradeAmount: item.tradeAmount
                        });
                    });
                } else {
                    gengiReq = {
                        additionToMarketValue: null,
                        unsettledSecuritiesTransactions: null,
                        comments: null,
                        divisionUnits: null,
                        gengi: this.localeService.parseLocalizedNumber(this.form.get('gengi').value),
                        dagsetning: this.form.get('dagsetning').value,
                        marketValue: null,
                        skammstofun: skammstofun,
                        ydaTransactions: null,
                    };
                }

                const req: ExposedGengiSkraningReq = {
                    gengi: gengiReq,
                    eignir: eignirReq,
                    gengiUnsettledTrades: gengiUnsettledTradesReq,
                };

                this.gengiService.SkraGengi(req).subscribe((res) => {
                    this.headerColumns = this.headerColumnsInitial;
                    this.fetchData();
                });
            }
        });
    }

    //#endregion

    //#region Main functions

    // Reiknar gengi
    calculateGengi() {
        if (!this.skraGengiSimple) {
            let vidskiptiGaerdagsins = this.localeService.parseLocalizedNumber(this.currentGengiFormFieldsContent.vidskiptiGaerdagsins);
            let vidbotVidMarkadsverd = this.localeService.parseLocalizedNumber(this.currentGengiFormFieldsContent.vidbotVidMarkadsverd);
            let ouppgerdVerdbrefavidskipti = this.localeService.parseLocalizedNumber(this.currentGengiFormFieldsContent.ouppgerdVerdbrefavidskipti);
            let markadsverd = this.localeService.parseLocalizedNumber(this.currentGengiFormFieldsContent.markadsverd);
            let totalAssetValue = markadsverd + vidskiptiGaerdagsins + vidbotVidMarkadsverd + ouppgerdVerdbrefavidskipti;
            let gengi =
                this.dagsuppgjorEntry.einingar_Alls == 0 || totalAssetValue == 0
                    ? this.localeService.localizeNumber(this.dagsuppgjorEntry.upphafs_gengi)
                    : this.localeService.localizeNumber((totalAssetValue / this.dagsuppgjorEntry.einingar_Alls).toFixed(0).toString());
            this.currentGengiFormFieldsContent.gengi = gengi;
            this.form.get('gengi').setValue(gengi);
            this.calculateGengiDifference();
        }
    }

    calculateGengiDifference() {
        try {
            this.mismunurFraSidustuSkraningu =
                this.localeService.parseLocalizedNumber(this.form.get('gengi').value) / +this.sidastaSkradaGengi.gengi;
        } catch { }
    }

    // Segir til um vikmörk fyrir alert fyrir markaðsverð
    checkGengiAlert(dif) {
        return (dif <= 0.95 || dif >= 1.05) && dif != 0;
    }

    checkTotalGengiAlert(dif) {
        return Math.abs(1 - dif) > 0.005;
    }

    //#endregion

    //#region Table Sort and Filter

    searchFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
        this.displayedData.filter = filterValue;
    }

    sortData(sort: Sort) {
        const data = this.displayedData.data.slice();
        if (!sort.active || sort.direction === '') {
            this.displayedData.data = data;
            return;
        }

        this.displayedData.data = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'closingPriceBefore':
                    return sortCompare(a.closingPriceBefore, b.closingPriceBefore, isAsc);
                case 'closingPriceDateBefore':
                    return sortCompare(a.closingPriceDateBefore, b.closingPriceDateBefore, isAsc);
                case 'closingPriceDateToday':
                    return sortCompare(a.closingPriceDateToday, b.closingPriceDateToday, isAsc);
                case 'closingPriceToday':
                    return sortCompare(a.closingPriceToday, b.closingPriceToday, isAsc);
                case 'marketValueBefore':
                    return sortCompare(a.marketValueBefore, b.marketValueBefore, isAsc);
                case 'marketValueToday':
                    return sortCompare(a.marketValueToday, b.marketValueToday, isAsc);
                case 'symbol':
                    return sortCompare(a.symbol, b.symbol, isAsc);
                case 'changeType':
                    return sortCompare(a.changeType, b.changeType, isAsc);
                default:
                    return 0;
            }
        });
    }

    //#endregion

}
